import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import { createImageSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const ButterflyItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly1%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly2%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly3%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly4%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly5%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly6%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/butterfly/batterfly7%401x.png'
    ),
];
